/**
 * UX 7.4 — the worker's own thread, the call the offline queue replays. Kept
 * apart from services/messaging.ts so the queue does not pull in Storage. The
 * server resolves the thread from the caller; `worker_dispatch` reaches only
 * their own.
 */
import { httpsCallableWithLog as httpsCallable } from './errorLog';
import { getFirebase } from './firebase';

export interface WorkerMessageInput {
  text: string;
  clientMessageId: string;
}

export async function postWorkerMessage(input: WorkerMessageInput): Promise<void> {
  const callable = httpsCallable<
    WorkerMessageInput & { type: 'worker_dispatch'; attachments: [] },
    { ok: true; conversationId: string; messageId: string }
  >(getFirebase().functions, 'postMessage');
  await callable({ ...input, type: 'worker_dispatch', attachments: [] });
}
